<script setup lang="ts">
const { loadLayout, layoutData } = useLayout()
await loadLayout()

const { loadIcon } = useDynamicIcons()
</script>

<template>
  <ul class="extra-links">
    <li
      v-if="$slots.before"
      class="extra-links__item"
    >
      <slot name="before" />
    </li>

    <li
      v-for="item in layoutData?.serviceLinks?.[0]?.Items || []"
      :key="item.id"
      class="extra-links__item"
    >
      <NuxtLink
        :to="item.Link"
        class="extra-links__link"
      >
        <NuxtIcon
          v-if="item.Icon"
          :name="loadIcon(item.Icon)"
        />
        <span class="extra-links__label">{{ item.Name }}</span>
      </NuxtLink>
    </li>

    <li
      v-if="$slots.after"
      class="extra-links__item"
    >
      <slot name="after" />
    </li>
  </ul>
</template>

<style>
@import url("~layers/components/Navigation/ExtraLinks.css");
</style>
